import { Injectable } from '@angular/core';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(private apiService: ApiService) {}

  async getResolvedTokens(tokenKeys: string[], customerId?: string, projectId?: string): Promise<Record<string, any>> {
    const body: { tokenKeys: string[]; customerId?: string; projectId?: string } = { tokenKeys };

    if (customerId) {
      body.customerId = customerId;
    } else if (projectId) {
      body.projectId = projectId;
    }

    const response = await this.apiService.postPromise<{ resolvedTokens: Record<string, any> }>(
      '/resolve-tokens',
      body,
    );
    return response.resolvedTokens || {};
  }

  async getDefaultTokenValues(tokenKeys: string[]): Promise<Record<string, any>> {
    const body = { tokenKeys };
    const response = await this.apiService.postPromise<{ defaultTokenValues: Record<string, any> }>(
      '/get-default-token-values',
      body,
    );
    return response.defaultTokenValues || {};
  }
}
